<div class="flex-col height100p">
    <sm-toolbar>
        <p-button icon="fas fa-run" label="Holen" (onClick)="getSystemInfo()"></p-button>
    </sm-toolbar>
    <textarea pInputTextarea spellcheck=false class="flex-item-fill overflow-y-auto height100p monospace no-resize" *ngIf="systemInfo != null" [autoResize]=false [ngModel]="systemInfo"></textarea>
</div>
